module.exports = __webpack_public_path__ + "static/dynamic-email-templates-dots-20f2165fbfaee836d848facd716cb804.svg";